<h1 ev-dialog-title>
  @if (viewMode() === 'main' || viewMode() === 'select-vehicle') {
  {{ languageService.languageJSON?.CarSelectorDialog_Title }}
  }
  @if (viewMode() === 'charging-stations' || viewMode() === 'charging-operators') {
  {{ languageService.languageJSON?.SettingsDialog_ChargingStationsSettings }}
  }
</h1>

<div ev-dialog-content data-testid="veh-opts-container">
  @if (viewMode() === 'main') {
  <!-- Main view -->
  <div class="header-area">
    <div class="car-icon">
      @if (selectedCar()?.Icon) {
      <img appVehicleImageFallback
        [src]="VEHICLE_IMAGE_URL.replace('$skin', settingsService.getMap().Skin).replace('$icon_name', selectedCar()?.Icon || '')" />
      }
    </div>
    <button class="car-name-button" type="button" data-testid="veh-opts-car-name-btn" (click)="openVehicleSelect()">
      <span class="car-name-main">{{ getCarDisplayName() }}</span>
      @if (getCarSubLabel() && getCarSubLabel() !== getCarDisplayName()) {
      <span class="car-name-sub">{{ getCarSubLabel() }}</span>
      }
    </button>
  </div>

  <div class="content-area">

    <div class="tab-selector">
      <button type="button" class="tab" data-testid="veh-opts-tab-range-btn" [class.active]="optionsTab() === 'range'" (click)="setOptionsTab('range')">
        {{ languageService.languageJSON?.Global_Range }}
      </button>
      <button type="button" class="tab" data-testid="veh-opts-tab-routing-btn" [class.active]="optionsTab() === 'routing'" (click)="setOptionsTab('routing')">
        {{ languageService.languageJSON?.Global_Routing }}
      </button>
      <button type="button" class="tab" data-testid="veh-opts-tab-charging-btn" [class.active]="optionsTab() === 'charging'" (click)="setOptionsTab('charging')">
        {{ languageService.languageJSON?.Global_Charging }}
      </button>
    </div>

    @if (optionsTab() === 'range') {
    <div class="options-tab-content scrollable">
      <app-range-options [sliderProperties]="sliderProperties()" (sliderDragEvent)="onSliderDrag($event)"
        (sliderChangeEvent)="onSliderChange($event)">
      </app-range-options>
    </div>
    }
    @if (optionsTab() === 'routing') {
    <div class="options-tab-content scrollable">
      <app-routing-options [(tollRoad)]="routingTollRoad" [(ferries)]="routingFerries" [(highways)]="routingHighways"
        [(tripRecording)]="tripRecordingSettings">
      </app-routing-options>
    </div>
    }
    @if (optionsTab() === 'charging') {
    <div class="options-tab-content scrollable">
      <app-charging-options [selectedCar]="selectedCar()" [fastChargeLimit]="fastChargeLimit()"
        [fastChargeLimitMin]="fastChargeLimitMin()" [fastChargeLimitMax]="fastChargeLimitMax()"
        [batteryStateOfHealth]="batteryStateOfHealth()" [batteryStateOfHealthMin]="batteryStateOfHealthMin()"
        [batteryStateOfHealthMax]="batteryStateOfHealthMax()" [selectedChargerTypes]="selectedChargerTypes()"
        [chargerTypes]="chargerTypes" (fastChargeLimitChange)="onFastChargeLimitChange($event)"
        (batteryStateOfHealthChange)="onBatteryStateOfHealthChange($event)"
        (chargerTypesChange)="onChargerTypesChanged($event)" (openChargingPage)="openChargingPage($event)">
      </app-charging-options>
    </div>
    }

    @if (csError()) {
    <div class="cs-error">{{ languageService.languageJSON?.CarSelectorDialog_ChargerTypes_Error }}</div>
    }
    @if (carSelectorError()) {
    <div class="error-outer">
      <h5 class="error-text">{{ languageService.languageJSON?.Global_SomethingWentWrong }}</h5>
    </div>
    }

  </div>
  }

  @if (viewMode() === 'select-vehicle') {
  <app-vehicle-select-page [ECars]="ECars()" [CarTypes]="CarTypes()" [selectedCar]="selectedCar()" [carType]="carType()"
    [carSubType]="carSubType()" [carTypeIndex]="carTypeIndex()" [multipleCarType]="multipleCarType()"
    [editedUserCar]="editedUserCar()" [customCarNameForm]="customCarNameForm" (carChanged)="carChangedHandler($event)"
    (carTypeChanged)="carTypeChangedHandler($event)" (carSubTypeChanged)="carSubTypeChangedHandler($event)"
    (switchToVehicle)="switchToVehicle($event)" (vehicleDeleted)="onVehicleDeleted($event)">
  </app-vehicle-select-page>
  }

  @if (viewMode() === 'charging-stations') {
  <div class="scrollable">
    <app-charging-stations-page [mode]="chargingStationsMode()" (back)="closeChargingPage()"
      (closeDialogRequested)="dialogRef.close()">
    </app-charging-stations-page>
  </div>
  }

  @if (viewMode() === 'charging-operators') {
  <div class="scrollable">
    <app-charging-operators-page [mode]="chargingOperatorsMode()" (back)="closeChargingPage()">
    </app-charging-operators-page>
  </div>
  }

</div>

@if (dialogContentIsLoading()) {
<div class="dialog-loader-outer">
  <app-ev-loader></app-ev-loader>
</div>
}


<div ev-dialog-actions>
  @if (viewMode() === 'main') {
  <button class="ev-button primary" name="ok_button" data-testid="veh-opts-ok-btn" mat-button (click)="clickOk()"
    [disabled]="csError() || dialogContentIsLoading()" [ngClass]="{'inactive': csError()}">
    {{ languageService.languageJSON?.Global_Ok }}
  </button>
  <!-- When the user has no vehicle yet (firstUserCar) the dialog must not be dismissable:
       the only way out is saving a vehicle via OK, so the Cancel button is hidden. -->
  @if (!data?.firstUserCar) {
  <button class="ev-button" name="cancel_button" data-testid="veh-opts-cancel-btn" mat-button (click)="clickCancel()">
    {{ languageService.languageJSON?.Global_Cancel }}
  </button>
  }
  }
  @if (viewMode() === 'select-vehicle') {
  <button class="ev-button primary" name="ok_button" data-testid="veh-opts-select-vehicle-ok-btn" mat-button (click)="confirmVehicleSelect()">
    {{ languageService.languageJSON?.Global_Ok }}
  </button>
  <button class="ev-button" name="cancel_button" data-testid="veh-opts-select-vehicle-cancel-btn" mat-button (click)="cancelVehicleSelect()">
    {{ languageService.languageJSON?.Global_Cancel }}
  </button>
  }
  @if (viewMode() === 'charging-stations' || viewMode() === 'charging-operators') {
  <button class="ev-button primary" name="back_button" data-testid="veh-opts-back-btn" mat-button (click)="closeChargingPage()">
    {{ languageService.languageJSON?.Global_Back }}
  </button>
  }
</div>